/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var NotificationBusinessType;

(function (NotificationBusinessType) {
  NotificationBusinessType["POLICY_UPDATE"] = "policy_update";
  NotificationBusinessType["POLICY_RENEWAL"] = "policy_renewal";
  NotificationBusinessType["POLICY_EXTEND"] = "policy_extend";
  NotificationBusinessType["POLICY_CANCEL"] = "policy_cancel";
  NotificationBusinessType["POLICY_SWITCH"] = "policy_switch";
  NotificationBusinessType["POLICY_PAUSE"] = "policy_pause";
  NotificationBusinessType["POLICY_UNPAUSE"] = "policy_unpause";
  NotificationBusinessType["POLICY_PAUSE_EDIT"] = "policy_pause_edit";
  NotificationBusinessType["POLICY_PAUSE_EXTEND"] = "policy_pause_extend";
  NotificationBusinessType["ANNUAL_POLICY_EXPIRING_SOON"] = "annual_policy_expiring_soon";
  NotificationBusinessType["CONTRACT_POLICY_EXPIRING_SOON"] = "contract_policy_expiring_soon";
})(NotificationBusinessType || (NotificationBusinessType = {}));